export const getFinancialYear = (): number => {
  const now = new Date();
  const year = now.getFullYear();
  return now.getMonth() > 2 ? year : year - 1;
};
